<template>
  <div id="nav">
    <div>

    </div>
    <a href="https://cerealcityscience.org"><img src="./../../assets/CerealCityScience_logo.svg"></a>
    <div class="link-area" v-if="showLogoutButton">

      <!-- <a href="/dashboard" class="links" v-if="userProfile && userProfile.userRole == 'teacher' && userProfile.active == true">Curriculum Dashboard</a> -->
      <a class="links" @click.prevent="setDashboard" v-if="userProfile && userProfile.userRole == 'admin' && userProfile.active == true">District Dashboard</a>
      <a class="links" @click.prevent="setTrainingDashboard" v-if="userProfile && userProfile.userRole == 'admin' && userProfile.active == true">View Training Registrations</a>
      <a href="/training" class="links" v-if="userProfile && userProfile.userRole == 'admin' && userProfile.active == true">Register a Training</a>
    </div>
    <div>
      <a @click="logout" v-if="userProfile && showLogoutButton">Log Out {{ userProfile.userFirstName }}</a>
    </div>
    <div>

    </div>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([ 'userProfile' ]),
    showLogoutButton() {
      if (this.$route.name === 'login' || this.$route.name === 'home' || this.$route.name == 'create-account') {
        return false
      } else if (this.$route.name === 'verify') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    logout() {
      fb.auth.signOut().then(() => {
        
        this.$store.dispatch('clearData')
        console.log('cleared')
        // window.location.reload()
        
      }).then(() => {          
          this.$router.push('/')
      }).catch(err => {
        console.log(err)
      })
    },
    setDashboard() {
      if (this.$route.name === 'dashboard') {
        this.$store.commit('SET_DISTRICT_ID', null)
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
      } else {
        this.$store.commit('SET_DISTRICT_ID', null)
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
        this.$router.push('/dashboard')
      }
    },
    setTrainingDashboard() {
      if (this.$route.name === 'dashboard') {
        this.$store.commit('SET_DISTRICT_ID', null)
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'trainingDashboard')
      } else {
        this.$store.commit('SET_DISTRICT_ID', null)
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'trainingDashboard')
        this.$router.push('/dashboard')
      }

    }
  }
}
</script>

<style lang="css" scoped>
#nav {
  width: 100%;
  display: grid;
  grid-template-columns: 60px 200px 1fr 200px 60px;
  grid-template-rows: auto;
  text-align: right;
  margin-top: 10px;
  border-bottom: 1px solid #cecece;
}
img {
  max-width: 200px;
  height: auto;
}
.link-area {
  margin: 20px;
  text-align: left;
}
.links {
  margin: 0 30px;
  color: #000812;
  font-size: 1.5em;
}
</style>
